var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      { staticClass: "px-5" },
      [
        _c("vue-slider", {
          attrs: {
            min: 10,
            max: 120,
            step: 10,
            interval: 10,
            marks: _vm.marks,
            tooltip: "active",
            "tooltip-formatter": _vm.formatter,
          },
          model: {
            value: _vm.width,
            callback: function ($$v) {
              _vm.width = $$v
            },
            expression: "width",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }